import React, { useMemo } from 'react';
import classNames from 'classnames';
import { DealOutcome } from 'models/DealRoom';
import { Link } from 'react-router-dom';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl } from 'components/ResolveImage/utils';
import { useTranslation } from 'react-i18next';
import { Industry } from 'models/Industry';
import { getDataRoomRoute } from 'utils';
import BlankDocumentIcon from 'icons/BlankDocument.icon';

import './DataRoomInvitationCard.styles.scss';
import './DataRoomInvitationCard.styles.responsive.scss';

type DataRoomInvitationCardProps = {
  className?: string;
  dataRoomId: string;
  title: string;
  dealOutcome: DealOutcome;
  otherDealOutcome: string;
  industry: Industry;
  imageSrc: string;
};

const DataRoomInvitationCard: React.FC<DataRoomInvitationCardProps> = (
  props,
) => {
  const {
    className,
    imageSrc,
    dataRoomId,
    title,
    dealOutcome,
    otherDealOutcome,
    industry,
  } = props;

  const { t } = useTranslation();

  const classes = classNames('data-room-invitation-card', className);

  const rerouteLink = useMemo(() => getDataRoomRoute(dataRoomId), [dataRoomId]);

  return (
    <div className={classes}>
      <div className="data-room-invitation-card__left">
        <div className="data-room-invitation-card__left__heading">
          <Link
            to={rerouteLink}
            className="data-room-invitation-card__left__heading__title"
          >
            {title}
          </Link>
          <Link
            to={rerouteLink}
            className="data-room-invitation-card__left__heading__deal-info"
          >
            <span>
              {dealOutcome === 'other' ? otherDealOutcome : t(dealOutcome)}
            </span>
            <span>{industry}</span>
          </Link>
        </div>

        <div className="data-room-invitation-card__left__actions">
          <Link to={rerouteLink} className="border">
            <BlankDocumentIcon />
            {t('manageDocuments')}
          </Link>
        </div>
      </div>

      <div className="data-room-invitation-card__image-container">
        <Link aria-label="Business details page" to={rerouteLink}>
          <ResolveImage src={getImgUrl(imageSrc, '480')} alt="Listing" />
        </Link>
      </div>
    </div>
  );
};

export default DataRoomInvitationCard;
